export enum RouteQueryParam {
  AccessToken = 'accessToken',
  Mode = 'mode',
  OrderId = 'orderId',
  PL_Category = 'kategoria',
  Query = 'query',
  Redirect = 'redirect',
  ReturnUrl = 'returnUrl',
  Socials = 'socials',
  SourceApp = 'sourceApp',
  Target = 'target',
  TargetApp = 'targetApp',
  Token = 'token',
  V = 'v',
}
